import { create } from 'zustand';

const usePlaceOrderFormStore = create((set) => ({
  placeOrderForm: [],
  setPlaceOrderForm: (newAttributes) =>
    set((state) => ({
      placeOrderForm:
        typeof newAttributes === 'function'
          ? newAttributes(state.placeOrderForm)
          : newAttributes
    }))
}));

export default usePlaceOrderFormStore;
